
const confirmForm = () => {

	$(document).on('submit', 'form.confirm', function(e){

		e.preventDefault();

		var $form = $(this);	
		var $msg =  $(this).attr('data-msg');

		if($msg === undefined)
			$msg = "Confirme la acción";


		$form.find('button').attr('disabled', 'disabled');

		swal({
		  title: $msg,
		  type: "warning",
		  showConfirmButton: true,
		  showCancelButton: true,
		  confirmButtonText: "Confirmar",
		  cancelButtonText: "Cancelar",
		  focusCancel: true
		})

		.then(function(result) {
		  
		  if (result.value) {
		  			  	
		  	$(document).off('submit', 'form.confirm');
		  	$form.unbind('submit').submit();	  	


		  } else {
		  	
		  	
		  	$form.find('button').removeAttr('disabled');	  	

		    return false;
		    
		  }
		});

	});

}

const confirmLink = () => {



	$(document).on('click', 'a.confirm', function(e){

		e.preventDefault();

		var $a = $(this);
		var $html = $(this).html();
		var $link = $(this).attr('href');
		var $msg =  $(this).attr('data-msg');

		if($msg === undefined)
			$msg = "Confirme la acción";

		$a.attr('disabled', 'disabled');
		$a.html('<i class="fas fa-ban"></i>');

		swal({
		  title: $msg,
		  type: "warning",
		  showConfirmButton: true,
		  showCancelButton: true,
		  confirmButtonText: "Confirmar",
		  cancelButtonText: "Cancelar",
		  focusCancel: true
		})

		.then(function(result) {
		  
		  if (result.value) {
		  			  	
		  	window.location.replace($link);


		  } else {
		  	
		  	
		  		
		  	$a.removeAttr('disabled');
		  	$a.html($html);

		    return false;
		    
		  }
		});


	});


	
}

const confirmSelect = () => {




	$( "select.confirm" )
	  .change(function () {
	    
	    var $select = $(this);
	    var $form = $(this).closest('form');
	    var $checkboxes = $form.find('input[type="checkbox"]');
	    var action = $( "select.confirm option:selected" ).val();
	    var text =  "¿" + $( "select.confirm option:selected" ).text() + "?";

	    var checked = $checkboxes.filter(':checked').length;

	    if(checked < 1)
	    	{
	    		swal("Debe seleccionar al menos una casilla.");
	    		return false;
	    	}

	    var permanent = "";

	    if ($( "select.confirm option:selected" ).attr('data-permanent'))
	    	permanent = "Esta acción no se puede deshacer.";


	    swal({      
	      title: text,
	      text: checked + " seleccionado(s). " + permanent,
	      type: "warning",
	      showConfirmButton: true,
	      showCancelButton: true,
	      confirmButtonText: "Confirmar",
	      cancelButtonText: "Cancelar",
	      focusCancel: true
	    })
	    .then(function(result) {
	      
	      if (result.value) {
	      		      	
	      	$form.submit();


	      } else {

	      	
	      	$( "select.confirm" ).val("");
	        return false;
	        
	      }
	    });

	    
	  });

	
}

export { confirmForm, confirmLink, confirmSelect }